
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Container,
  Grid,
  Card,
  CardContent,
  Divider,
  Alert,
  Fade,
  Zoom,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import {
  Home as HomeIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Add as AddIcon,
  CloudUpload as CloudUploadIcon,
} from "@mui/icons-material";
import { MyContext } from "../../App";
import {
  deleteData,
  editData,
  fetchDataFromApi,
  postData,
} from "../../utils/api";
import { useNavigate } from "react-router-dom";

const AddProductSize = () => {
  const [editId, setEditId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [productSizeData, setProductSizeData] = useState([]);
  const [formFields, setFormFields] = useState({
    size: "",
  });

  const history = useNavigate();
  const input = useRef();
  const context = useContext(MyContext);

  const inputChange = (e) => {
    setFormFields(() => ({
      ...formFields,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    fetchDataFromApi("/api/productSIZE").then((res) => {
      setProductSizeData(res);
    });
  }, []);

  const addproductSize = (e) => {
    e.preventDefault();

    if (formFields.size === "") {
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Please add Product size",
      });
      return false;
    }

    setIsLoading(true);

    if (editId === "") {
      postData("/api/productSIZE/create", formFields).then((res) => {
        setIsLoading(false);
        setFormFields({
          size: "",
        });

        fetchDataFromApi("/api/productSIZE").then((res) => {
          setProductSizeData(res);
        });
      });
    } else {
      editData(`/api/productSIZE/${editId}`, formFields).then((res) => {
        fetchDataFromApi("/api/productSIZE").then((res) => {
          setProductSizeData(res);
          setEditId("");
          setIsLoading(false);
          setFormFields({
            size: "",
          });
        });
      });
    }
  };

  const deleteItem = (id) => {
    deleteData(`/api/productSIZE/${id}`).then((res) => {
      fetchDataFromApi("/api/productSIZE").then((res) => {
        setProductSizeData(res);
      });
    });
  };

  const updateData = (id) => {
    input.current.focus();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    fetchDataFromApi(`/api/productSIZE/${id}`).then((res) => {
      setEditId(id);
      setFormFields({
        size: res.size,
      });
    });
  };

  const resetForm = () => {
    setEditId("");
    setFormFields({ size: "" });
  };

  return (
    <Box sx={{
      pt: { xs: 10, sm: 12, md: 14 },
      minHeight: '100vh'
    }}>
      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: "linear-gradient(135deg, #b5faeeff 0%, #f5c7f5ff 100%)",
            color: "white",
            borderRadius: 2,
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="space-between" >
            <Box>
              <Typography variant="h4" fontWeight="bold" gutterBottom >
                Product Size Management
              </Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <HomeIcon fontSize="small" sx={{
                  backgroundColor: "rgba(250, 237, 162, 0.2)",
                  color: "black",
                  fontWeight: "bold",
                }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Dashboard / Product SIZE / Add Product SIZE
                </Typography>
              </Box>
            </Box>
            <Box>
              <Chip
                label={`${productSizeData.length} Sizes`}
                sx={{
                  backgroundColor: "rgba(250, 237, 162, 0.2)",
                  color: "black",
                  fontWeight: "bold",
                }}
              />
            </Box>
          </Box>
        </Paper>

        <Grid container spacing={3}>
          {/* Form Section */}
          <Grid item xs={12} lg={4}>
            <Fade in timeout={600}>
              <Card
                elevation={3}
                sx={{
                  borderRadius: 3,
                  overflow: "visible",
                  position: "sticky",
                  top: { xs: 90, sm: 100, md: 120 },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box display="flex" alignItems="center" mb={3}>
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: 2,
                        backgroundColor: "primary.main",
                        color: "white",
                        mr: 2,
                      }}
                    >
                      <AddIcon />
                    </Box>
                    <Typography variant="h5" fontWeight="600">
                      {editId ? "Edit Size" : "Add New Size"}
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <form onSubmit={addproductSize}>
                    <TextField
                      fullWidth
                      label="Product Size"
                      name="size"
                      value={formFields.size}
                      onChange={inputChange}
                      ref={input}
                      variant="outlined"
                      placeholder="Enter size (e.g., Small, Medium, Large, XL)"
                      sx={{
                        mb: 3,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                      InputProps={{
                        sx: {
                          fontSize: "1.1rem",
                          py: 1,
                        },
                      }}
                    />

                    <Box display="flex" gap={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        disabled={isLoading}
                        startIcon={
                          isLoading ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : editId ? (
                            <SaveIcon />
                          ) : (
                            <CloudUploadIcon />
                          )
                        }
                        sx={{
                          py: 1.5,
                          borderRadius: 2,
                          textTransform: "none",
                          fontSize: "1rem",
                          fontWeight: "600",
                          background: editId
                            ? "linear-gradient(45deg, #FF9800 30%, #FFB74D 90%)"
                            : "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
                          boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
                          "&:hover": {
                            background: editId
                              ? "linear-gradient(45deg, #F57C00 30%, #FF9800 90%)"
                              : "linear-gradient(45deg, #1976D2 30%, #2196F3 90%)",
                          },
                          "&:disabled": {
                            background: "rgba(0, 0, 0, 0.12)",
                            color: "rgba(0, 0, 0, 0.26)",
                          },
                        }}
                      >
                        {isLoading
                          ? "Processing..."
                          : editId
                            ? "Update Size"
                            : "Add Size"
                        }
                      </Button>

                      {editId && (
                        <Button
                          variant="outlined"
                          onClick={resetForm}
                          sx={{
                            minWidth: 60,
                            borderRadius: 2,
                            borderColor: "grey.300",
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                    </Box>
                  </form>

                  {editId && (
                    <Alert
                      severity="info"
                      sx={{
                        mt: 2,
                        borderRadius: 2,
                        "& .MuiAlert-message": {
                          fontSize: "0.9rem",
                        },
                      }}
                    >
                      You are currently editing a size. Update or cancel to add new
                      sizes.
                    </Alert>
                  )}
                </CardContent>
              </Card>
            </Fade>
          </Grid>

          {/* Table Section with Scroll */}
          <Grid item xs={12} lg={8}>
            <Fade in timeout={800}>
              <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent sx={{ p: 0 }}>
                  <Box sx={{ p: 3, pb: 0 }}>
                    <Typography variant="h5" fontWeight="600" gutterBottom>
                      Existing Product Sizes
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Manage all your product sizes from here
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  {productSizeData.length === 0 ? (
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      py={8}
                    >
                      <Box
                        sx={{
                          width: 120,
                          height: 120,
                          borderRadius: "50%",
                          backgroundColor: "grey.100",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2,
                        }}
                      >
                        <AddIcon sx={{ fontSize: 48, color: "grey.400" }} />
                      </Box>
                      <Typography variant="h6" color="text.secondary" gutterBottom>
                        No sizes added yet
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Add your first product size using the form
                      </Typography>
                    </Box>
                  ) : (
                    <TableContainer
                      sx={{
                        maxHeight: { xs: 300, sm: 400, md: 500, lg: 600 },
                        overflowY: 'auto',
                        overflowX: 'auto',
                        '&::-webkit-scrollbar': {
                          width: 8,
                          height: 8,
                        },
                        '&::-webkit-scrollbar-track': {
                          backgroundColor: '#064c85ff',
                          borderRadius: 10,
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: '#045e6eff',
                          borderRadius: 10,
                          '&:hover': {
                            backgroundColor: '#056d1fff',
                          },
                        },
                        '&::-webkit-scrollbar-corner': {
                          backgroundColor: '#058d27ff',
                        },
                      }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "grey.50" }}>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                fontSize: "1rem",
                                py: 2,
                                backgroundColor: "grey.50",
                                position: "sticky",
                                top: 0,
                                zIndex: 100,
                              }}
                            >
                              Product Size
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{
                                fontWeight: "bold",
                                fontSize: "1rem",
                                py: 2,
                                width: "150px",
                                backgroundColor: "grey.50",
                                position: "sticky",
                                top: 0,
                                zIndex: 100,
                              }}
                            >
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {productSizeData?.map((item, index) => (
                            <Zoom
                              in
                              timeout={300 + index * 100}
                              key={item.id}
                            >
                              <TableRow
                                hover
                                sx={{
                                  "&:hover": {
                                    backgroundColor: "action.hover",
                                  },
                                  borderLeft:
                                    editId === item.id
                                      ? "4px solid #FF9800"
                                      : "4px solid transparent",
                                }}
                              >
                                <TableCell sx={{ py: 2 }}>
                                  <Chip
                                    label={item.size}
                                    variant={
                                      editId === item.id ? "filled" : "outlined"
                                    }
                                    color={
                                      editId === item.id ? "warning" : "default"
                                    }
                                    sx={{
                                      fontWeight: "500",
                                      fontSize: "0.9rem",
                                      px: 1,
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="center" sx={{ py: 2 }}>
                                  <Box display="flex" justifyContent="center" gap={1}>
                                    <Tooltip title="Edit Size">
                                      <IconButton
                                        size="small"
                                        onClick={() => updateData(item.id)}
                                        sx={{
                                          color: "primary.main",
                                          "&:hover": {
                                            backgroundColor: "primary.lighter",
                                          },
                                        }}
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete Size">
                                      <IconButton
                                        size="small"
                                        onClick={() => deleteItem(item.id)}
                                        sx={{
                                          color: "error.main",
                                          "&:hover": {
                                            backgroundColor: "error.lighter",
                                          },
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            </Zoom>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </CardContent>
              </Card>
            </Fade>
          </Grid>


        </Grid>
      </Container>
    </Box>
  );
};

export default AddProductSize;























